import { useState } from 'react';
import axios from 'axios';
import { FloppyDisk } from '@phosphor-icons/react';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { Textarea } from '../../ui/textarea';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../ui/dialog';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function BatimentFormDialog({ chantierId, batiment, onSaved, onClose }) {
  const isEdit = !!batiment;
  const [form, setForm] = useState({
    nom: batiment?.nom || '',
    adresse: batiment?.adresse || '',
    description: batiment?.description || '',
  });
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (!form.nom.trim()) { toast.error('Le nom est obligatoire'); return; }
    setSaving(true);
    try {
      if (isEdit) {
        await axios.put(`${API_URL}/api/chantiers/${chantierId}/batiments/${batiment.id}`, form, { withCredentials: true });
      } else {
        await axios.post(`${API_URL}/api/chantiers/${chantierId}/batiments`, { ...form, ordre: 0 }, { withCredentials: true });
      }
      toast.success(isEdit ? 'Bâtiment modifié' : 'Bâtiment ajouté');
      onSaved();
      onClose();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erreur');
    } finally { setSaving(false); }
  };

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="max-w-md" data-testid="batiment-form-dialog">
        <DialogHeader>
          <DialogTitle style={{ fontFamily: 'DM Serif Display, serif' }}>
            {isEdit ? 'Modifier le bâtiment' : 'Ajouter un bâtiment'}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <div>
            <Label className="text-xs">Nom *</Label>
            <Input value={form.nom} onChange={e => setForm({ ...form, nom: e.target.value })}
              placeholder="Bâtiment A, Maison principale…" className="rounded-none mt-1" autoFocus
              data-testid="batiment-form-nom" />
          </div>
          <div>
            <Label className="text-xs">Adresse (optionnel)</Label>
            <Input value={form.adresse} onChange={e => setForm({ ...form, adresse: e.target.value })}
              className="rounded-none mt-1 text-sm" data-testid="batiment-form-adresse" />
          </div>
          <div>
            <Label className="text-xs">Notes (optionnel)</Label>
            <Textarea value={form.description} onChange={e => setForm({ ...form, description: e.target.value })}
              rows={2} className="rounded-none mt-1 text-sm" />
          </div>
          <div className="flex justify-end gap-2 pt-2">
            <Button variant="outline" onClick={onClose} className="rounded-none">Annuler</Button>
            <Button onClick={save} disabled={saving}
              className="bg-[#C75B39] hover:bg-[#D97B5C] rounded-none gap-2"
              data-testid="batiment-form-save">
              <FloppyDisk size={14} /> {isEdit ? 'Enregistrer' : 'Ajouter'}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
